import React from 'react';

import { ModalV2Props } from '../../Modal/ModalV2';
import { ScreenReaderText } from '../../Modal/ModalV2.styles';

import OnboardContainer from '../OnboardContainer';

import { ModalContainer } from './OnboardModalContainer.styles';
import { OnboardContainerProps } from '../OnboardContainer/OnboardContainer';

export type OnboardModalContainerProps = OnboardContainerProps &
  Omit<ModalV2Props, 'dialogHeadingId'> & {
    children?: React.ReactNode;
    fullScreen?: boolean;
  };

const OnboardModalContainer = ({
  businessUnit,
  businessUnitComponent,
  className,
  children,
  fullScreen = true,
  progressTitles,
  onClose = () => undefined,
  showProgressBar,
  onOnboardSuccessCb,
  onOnboardingStarted,
  onLoginSuccess,
  // Modal Props
  triggerRef,
  closeOnOverlayClick = false,
  closeOnEscape = false,
  lockBgScrolling = false,
  rootId,
}: OnboardModalContainerProps): JSX.Element => {
  const dialogHeadingId = 'modal-content';
  return (
    <ModalContainer
      triggerRef={triggerRef}
      dialogHeadingId={dialogHeadingId}
      className={className}
      fullScreen={fullScreen}
      onClose={onClose}
      showCloseButton={false}
      closeOnOverlayClick={closeOnOverlayClick}
      closeOnEscape={closeOnEscape}
      lockBgScrolling={lockBgScrolling}
      rootId={rootId}
    >
      <ScreenReaderText id={dialogHeadingId}>Zola Account Creation</ScreenReaderText>
      <OnboardContainer
        onClose={onClose}
        onOnboardSuccessCb={onOnboardSuccessCb}
        onLoginSuccess={onLoginSuccess}
        progressTitles={progressTitles}
        businessUnit={businessUnit}
        businessUnitComponent={businessUnitComponent}
        onOnboardingStarted={onOnboardingStarted}
        showProgressBar={showProgressBar}
      >
        {children}
      </OnboardContainer>
    </ModalContainer>
  );
};
export default OnboardModalContainer;
